import { render } from "./AudioMessage.vue?vue&type=template&id=391028e0&scoped=true&ts=true"
import script from "./AudioMessage.vue?vue&type=script&lang=ts"
export * from "./AudioMessage.vue?vue&type=script&lang=ts"

import "./AudioMessage.vue?vue&type=style&index=0&id=391028e0&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391028e0"]])

export default __exports__